import { Injectable } from '@angular/core';

export interface IProvince {
  uniqueId: string;
  code: string;
  name: string;
  countryId: number;
}

@Injectable({
  providedIn: 'root'
})
export class CountryStoreService {
  provinces = [
    { uniqueId: '78e3ae95-117b-40a2-9bf0-67068966815e', code: 'AB', name: 'Alberta', countryId: 1 },
    { uniqueId: '756a6f3e-b63f-4353-a09c-5cd6beb55c01', code: 'BC', name: 'British Columbia', countryId: 1 },
    { uniqueId: '649deaf7-3f2c-47fd-96e0-02c780cb9a0b', code: 'MB', name: 'Manitoba', countryId: 1 },
    { uniqueId: '0b32c9dd-4788-41eb-9a58-181ea75f0467', code: 'NB', name: 'New Brunswick', countryId: 1 },
    { uniqueId: 'cbafe0a4-df2a-4d55-9ea8-0e04eaa5cc2a', code: 'NL', name: 'Newfoundland and Labrador', countryId: 1 },
    { uniqueId: 'ab05b3fd-739f-474c-b1e4-c82efc1c4769', code: 'NS', name: 'Nova Scotia', countryId: 1 },
    { uniqueId: '006e4d4b-3d04-4193-8088-df00f5ae1b1c', code: 'NT', name: 'Northwest Territories', countryId: 1 },
    { uniqueId: '2dde5c55-f8c4-462e-8e3c-9ba1833f79d8', code: 'NU', name: 'Nunavut', countryId: 1 },
    { uniqueId: 'c6731f2b-74f2-434d-a359-f1226e5f9582', code: 'ON', name: 'Ontario', countryId: 1 },
    { uniqueId: '4b1e9de5-0647-41fe-bf7b-2bbe279e2f4a', code: 'PE', name: 'Prince Edward Island', countryId: 1 },
    { uniqueId: 'ec1417c1-13b6-4d9d-b6b6-7ec5ead03f19', code: 'QC', name: 'Quebec', countryId: 1 },
    { uniqueId: '4ba9fd2c-acee-411d-8852-821db0c5e9a2', code: 'SK', name: 'Saskatchewan', countryId: 1 },
    { uniqueId: 'b4377d47-420f-4203-b8ee-de756b45d9ae', code: 'YT', name: 'Yukon', countryId: 1 }
  ];

  constructor() {}

  getProvinceNameByUniqueId(uniqueId: string): string {
    return this.getProvince(uniqueId)?.name || '';
  }

  getCountryIdByUnique(uniqueId: string): number {
    return this.getProvince(uniqueId)?.countryId || undefined;
  }

  private getProvince(uniqueId) {
    return this.provinces.find(province => province.uniqueId === uniqueId);
  }
}
